import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const IsLoginRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        !localStorage.getItem('Token')
            ? <Component {...props} />
            : (
                <Redirect to={{ pathname: '/panel/search' }} /> )
    )} />
);
